const YoutubeVideoProvider = `
  fragment YoutubeVideoProvider on YoutubeVideoProvider {
    providerType
    videoId
  }
`
export default YoutubeVideoProvider
